module.exports = __webpack_public_path__ + "static/assets/8101677a4158d25ebfc3a36059f15629.png";